import React from 'react'
import Icon, {
  CustomIconComponentProps,
} from '@ant-design/icons/lib/components/Icon'

const svg = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8456_2907)">
      <rect width="12" height="12" rx="2" fill="#D9D9D9" />
      <circle cx="3" cy="6" r="0.75" fill="white" />
      <circle cx="6" cy="6" r="0.75" fill="white" />
      <circle cx="9" cy="6" r="0.75" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_8456_2907">
        <rect width="12" height="12" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const NonePriority = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={svg} {...props} />
)
